import { PartnerType } from "@tm/isomorphic-utils";
import Head from "next/head";

interface HeadTags {
  title: string;
  canonical: string;
  metaTags?: {
    name: string;
    content: string;
  }[];
  schema?: any;
}

export function withSeoHeadTags(
  component: JSX.Element,
  headTags: HeadTags,
  partner: PartnerType,
  longImageUrl: string
) {
  return (
    <>
      <Head>
        <title>{headTags?.title || "Travel Insurance - MakeMyTrip"}</title>

        {headTags?.metaTags?.map((metaTag, index) => {
          if (metaTag.name && metaTag.content) {
            return (
              <meta key={index} name={metaTag.name} content={metaTag.content} />
            );
          }
        })}

        {headTags?.title && (
          <meta property="og:title" content={headTags?.title} />
        )}
        {headTags?.metaTags?.find((meta) => meta.name === "description")
          ?.content && (
          <meta
            property="og:description"
            content={
              headTags?.metaTags?.find((meta) => meta.name === "description")
                ?.content
            }
          />
        )}
        {longImageUrl && (
          <>
            <meta property="og:image" content={longImageUrl} />
          </>
        )}
        {headTags?.title && (
          <meta name="twitter:title" content={headTags?.title} />
        )}
        {headTags?.metaTags?.find((meta) => meta.name === "description")
          ?.content && (
          <meta
            name="twitter:description"
            content={
              headTags?.metaTags?.find((meta) => meta.name === "description")
                ?.content
            }
          />
        )}
        {longImageUrl && <meta name="twitter:image" content={longImageUrl} />}

        {headTags?.schema?.map((schema, index) => {
          return (
            <script
              type="application/ld+json"
              key={`schema-${index}`}
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(schema),
              }}
            />
          );
        })}

        {headTags?.canonical ? (
          <link rel="canonical" href={headTags.canonical} />
        ) : null}
      </Head>
      {component}
    </>
  );
}
